import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('ff_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('ff_token');
      localStorage.removeItem('ff_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const getImageUrl = (storagePath) => {
  const token = localStorage.getItem('ff_token');
  return `${API_BASE}/files/${storagePath}?auth=${token}`;
};

// Public (no-auth) axios instance for the shared client-view page.
export const publicApi = axios.create({ baseURL: API_BASE });

export const publicVideoUrl = (token, storagePath, accessKey) =>
  `${API_BASE}/public/share/${token}/file/${storagePath}${accessKey ? `?k=${accessKey}` : ''}`;

export default api;
